class TimelineVideoCallout {
    constructor(section) {
        this.section = section;

        this.trigger = section.querySelector('[data-video-trigger]');
        this.modal = section.querySelector('[data-video-modal]');
        this.closeButtons = section.querySelectorAll('[data-video-close]');
        this.popupIframe = section.querySelector('[data-popup-iframe]');
        this.popupVideo = section.querySelector('.timeline-video-callout__video-element--popup');

        this.inlineTrigger = section.querySelector('[data-inline-trigger]');
        this.inlinePoster = section.querySelector('[data-inline-poster]');
        this.inlineVideoWrap = section.querySelector('[data-inline-video]');
        this.inlineIframe = section.querySelector('[data-inline-iframe]');
        this.inlineVideo = section.querySelector('.timeline-video-callout__video-element--inline');

        this.handleEsc = this.handleEsc.bind(this);
        this.bindEvents();
    }

    bindEvents() {
        if (this.trigger && this.modal) {
            this.trigger.addEventListener('click', () => this.openModal());
        }

        this.closeButtons.forEach((button) => {
            button.addEventListener('click', () => this.closeModal());
        });

        if (this.inlineTrigger) {
            this.inlineTrigger.addEventListener('click', () => this.playInlineVideo());
        }
    }

    playInlineVideo() {
        if (this.inlinePoster) {
            this.inlinePoster.hidden = true;
        }

        if (this.inlineVideoWrap) {
            this.inlineVideoWrap.hidden = false;
        }

        if (this.inlineIframe && this.inlineIframe.dataset.src) {
            this.inlineIframe.src = this.inlineIframe.dataset.src;
        }

        if (this.inlineVideo) {
            const playPromise = this.inlineVideo.play();

            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
            }
        }
    }

    openModal() {
        this.modal.hidden = false;
        document.documentElement.classList.add('overflow-hidden');

        if (this.popupIframe && this.popupIframe.dataset.src) {
            this.popupIframe.src = this.popupIframe.dataset.src;
        }

        if (this.popupVideo) {
            const playPromise = this.popupVideo.play();

            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
            }
        }

        document.addEventListener('keydown', this.handleEsc);
    }

    closeModal() {
        if (!this.modal) return;

        this.modal.hidden = true;
        document.documentElement.classList.remove('overflow-hidden');

        if (this.popupIframe) {
            this.popupIframe.src = '';
        }

        if (this.popupVideo) {
            this.popupVideo.pause();
            this.popupVideo.currentTime = 0;
        }

        document.removeEventListener('keydown', this.handleEsc);
    }

    handleEsc(event) {
        if (event.key === 'Escape') {
            this.closeModal();
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.timeline-video-callout');

    sections.forEach((section) => {
        new TimelineVideoCallout(section);
    });
});